import { AppDefinition } from '../../types/apps';

export const CANVAS_EVENTS = {
  ELEMENT_ADDED: 'CANVAS_ELEMENT_ADDED',
  ELEMENT_UPDATED: 'CANVAS_ELEMENT_UPDATED',
  ELEMENT_DELETED: 'CANVAS_ELEMENT_DELETED',
  VIEWPORT_CHANGED: 'CANVAS_VIEWPORT_CHANGED',
} as const;

export const CanvasAppDefinition: AppDefinition = {
  appId: 'canvas',
  name: 'Canvas',
  version: '1.0.0',
  description: 'Simple visual workspace - draw, write sticky notes, and organize ideas spatially',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'PaintBrush',
    phosphorWeight: 'duotone',
    color: '#7c3aed' // Dark violet/purple
  },
  entityTypes: ['Canvas'],
  component: 'CanvasApp',
  requiresProps: false,
  requiresEntity: false,
  events: CANVAS_EVENTS,
  
  // Commands for AI integration
  agenticToolIds: [
    'canvas_create',
    'canvas_add_text',
    'canvas_add_image'
  ],
  
  // Keyboard shortcuts
  hotkeys: {
    'v': 'selectTool',
    't': 'textTool',
    'p': 'pencilTool',
    '+': 'zoomIn',
    '-': 'zoomOut',
    '1': 'fitAll'
  }
};

